import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useGetUrvDataQuery } from '@/api'
import { selectActiveBuildingId } from '@/features/building/buildingSlice'

/**
 * Хук для работы с данными URV
 * @returns {Object} - объект, содержащий данные и функции для управления таблицей
 */

export default function useUrvData() {
  const [page, setPage] = useState(1)
  const [size, setSize] = useState(25)
  const [searchInput, setSearchInput] = useState('')
  const [search, setSearch] = useState('')
  const activeBuildingId = useSelector(selectActiveBuildingId);

  const queryParams = {
    buildingId: activeBuildingId,
    page,
    size,
    search
  }

  const { data, isLoading } = useGetUrvDataQuery(queryParams, {
    skip: !activeBuildingId
  })

  const handleSearch = () => {
    setSearch(searchInput.trim())
    setPage(1)
  }

  const handlePageChange = (_, newPage) => {
    setPage(newPage + 1)
  }

  const handleRowsPerPageChange = (e) => {
    setSize(parseInt(e.target.value, 10))
    setPage(1)
  }

  return {
    data,
    isLoading,
    page: page - 1,
    size,
    searchInput,
    setSearchInput,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
    totalCount: data?.metadata?.total_count || 0
  }
}
